<template>
	<div>
		<el-dialog title="发票申领" :visible.sync="sldiag"  width="800px" :close-on-click-modal="false" v-dialogDrag>
            <!-- <minhead :headtitle="sltitle" :isdiag="true"></minhead> -->
			<el-form :model="docApplyInfoForm" :rules="rules" ref="docApplyInfoForm" class="demo-ruleForm" style="padding-left: 20px;">
                <div  class="form">
                <div class="Centerupdown"> 
                    <div class="demo-ruleForm-item">
                        <el-form-item label="发票类型:" prop="faplxdm" :label-width="formLabelWidth">
                            <el-select v-model="docApplyInfoForm.faplxdm" style="width: 215px;"  value="">
                                    <el-option label="电子普票" value="026"></el-option>
                                    <el-option label="电子专票" value="028"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="demo-ruleForm-item">
                        <el-form-item label="申领数量(本/卷):" prop="shenlsl" :label-width="formLabelWidth">
                            <el-input-number :min="1" oninput="if(value<1)value=1" v-model="docApplyInfoForm.shenlsl" placeholder="单行输入" style="width:215px" ></el-input-number>
                        </el-form-item>

                    </div>
                </div>
                <div class="Centerupdown">
                    <div class="demo-ruleForm-item">
                        <el-form-item label="经办人姓名:" prop="jingbrxm" :label-width="formLabelWidth">
                            <el-input v-model="docApplyInfoForm.jingbrxm" placeholder="单行输入" style="width:215px" ></el-input>
                        </el-form-item>
                    </div>
                    <div class="demo-ruleForm-item">
                        <el-form-item label="证件类型:" prop="zhengjlx" :label-width="formLabelWidth">
                            <el-select v-model="docApplyInfoForm.zhengjlx" style="width: 215px;"  value="">
                                <el-option v-for="item in selectZhengjlx" :key="item.value" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="Centerupdown">
                    <div class="demo-ruleForm-item">
                        <el-form-item label="证件号码:" prop="zhengjhm" :label-width="formLabelWidth">
                            <el-input v-model="docApplyInfoForm.zhengjhm" placeholder="单行输入" style="width:215px" ></el-input>
                        </el-form-item>
                    </div>
                    <div class="demo-ruleForm-item">
                        <el-form-item label="申领说明:" prop="shenlsm" :label-width="formLabelWidth">
                            <el-input
                            style="width: 215px;"
                              type="textarea"
                              :rows="2"
                              placeholder="多行输入"
                              v-model="docApplyInfoForm.shenlsm">
                            </el-input>
                        </el-form-item>
                     </div>
                 </div>
                </div>
			</el-form>
			<div style="margin-top: 31px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div style="justify-content: right; display: flex;margin-right: 17px;">
					<div class="addstyle" style="width: 100px;margin-left: 20px;" @click="submitForm('docApplyInfoForm')">申领</div>
					<div  class="backstyle" style="width: 100px;margin-left: 20px;"@click="sldiag = false">关闭</div>
				</div>
			</div>
		</el-dialog>

        <el-dialog title="发票段明细" :visible.sync="showApplyDetailDialogVisible"  width="800px" :close-on-click-modal="false" v-dialogDrag>
            <!-- <minhead :headtitle="detailTitle" :isdiag="true"></minhead> -->
            <div class="detail-dialog">
                <div style="padding-top: 10px;">
                    <el-table :data="detailTableData" border stripe height="300px" class="table" ref="companyTable">
                        <el-table-column prop="fapdm" label="发票代码" align="center"></el-table-column>
                        <el-table-column prop="qishm" label="起始号码" align="center"></el-table-column>
                        <el-table-column prop="zhongzhm" label="终止号码" align="center"></el-table-column>
                        <el-table-column prop="fens" label="份数" align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div style="margin-top: 31px;padding-bottom: 21px;" class="between-line">
                <div></div>
                <div class="rightbuttom">
                    <div @click="showApplyDetailDialogVisible = false">关闭</div>
                </div>
            </div>
        </el-dialog>

		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
				<!-- 	<el-button type="primary" plain style="width: 100px;" @click="forsl('发票申领')">
						申领
						<i class="el-icon-money el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="forsl('发票申领')">
						<samp>
						申领
						<i class="el-icon-money el-icon--right"></i>
						</samp>
					</div>
				<!-- 	<el-button type="primary" plain style="width: 100px;" @click="batchBackOutDocApply">
						撤销
						<i class="el-icon-refresh-left  el-icon--right"></i>
					</el-button> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="batchBackOutDocApply">
						<samp>
						撤销
						<i class="el-icon-refresh-left  el-icon--right"></i>
						</samp>
					</div>
				</div>
				<div class="Centerupdown">
					<el-input style="width: 300px;margin-left: 20px;margin-right: 16px;" clearable placeholder="发票类型代码,申领状态" prefix-icon="el-icon-search" v-model="likeSearchvalue" @input="changeserch"></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
				<el-table :data="tableData" border @selection-change="handleSelectionChange" style="width: 100%"  height="calc(100vh - 262px )" ref="multipleTable">
                    <el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="yushenqbh" label="预申请编号" align="center" min-width="100"></el-table-column>
                    <el-table-column prop="shenlxh" label="申领序号" align="center" min-width="100"></el-table-column>
					<el-table-column prop="faplxdm" label="发票类型" align="center" min-width="100" :formatter="formaterFalxdm"></el-table-column>
					<el-table-column prop="shenlsl" label="申领数量（本/卷）" align="center" min-width="100"></el-table-column>
					<el-table-column prop="shenlsj" label="申领日期" align="left" min-width="160px" show-overflow-tooltip>
                        <template slot-scope="scope">
									<span >
										{{yyyyMMdd(scope.row.shenlsj)}}
									</span>
                        </template>
                    </el-table-column>
					<el-table-column fixed="right" width="100" label="发票段信息" align="left" min-width="160px" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleCheck(scope.$index, scope.row, '查看明细信息')">查看明细信息</el-button>
                        </template>
                    </el-table-column>
					<el-table-column prop="chulzt" label="申请状态" align="center"min-width="100" :formatter="formaterChulzt"></el-table-column>
					<el-table-column fixed="right" label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="handleCheck(scope.$index, scope.row, '撤销申领')">撤销</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
            likeSearchvalue: '',
			sldiag:false,
			/* 开具弹框 */
			page: 1,
			pagenum: 10,
			totalcount: 10,
			tableData: [{}, {}, {}, {}],
            detailTableData: [{}, {}, {}, {}],
			headtitle: ['库存管理', '发票申领管理'],
			sltitle:['发票申领'],
            detailTitle:['发票段明细'],
            showApplyDetailDialogVisible:false,
            docApplyInfoForm: {
                faplxdm: '',
                shenlsl: '',
                jingbrxm: '',
                zhengjlx: '',
                zhengjhm: '',
                shenlsm: ''
            },
            rules: {
                faplxdm: [{ required: true, message: '请选择发票类型代码', trigger: 'blur' }],
                shenlsl: [{ required: true, message: '请输入申领数量', trigger: 'blur' }],
                jingbrxm: [{ required: true, message: '请输入经办人姓名', trigger: 'blur' }],
                zhengjlx: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
                zhengjhm: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
            },
			formLabelWidth: '150px',
            selectIds:[],
            selectRows:[],
            selectZhengjlx:[],
			tableHeight:""
		};
	},
	created() {
        this.getApplyInfoList();
        this.initSelectZhengjlx();
    },
	
	mounted() {
		 this.repairtable();
	},
	methods: {
        repairtable(){
            this.$nextTick(() => {
                this.tableHeight = this.diagheightzhengshutiankai();
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 300);
                window.onresize = () => {
                    this.tableHeight = this.diagheightzhengshutiankai();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                };
            });
        },
		forsl(title){
            this.$nextTick(() => {
                this.$refs['docApplyInfoForm'].clearValidate();
            });
            this.sldiag = true;
            this.title=title;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getApplyInfoList();
		},
		handleCurrentChange(val) {
			this.page = val;
            this.getApplyInfoList();
		},
        formaterChulzt(row, column, cellValue, index)
        {
            /**
             * 1：成功
             * 2：失败
             * 0：申领中
             * 3：已撤销
             */
            let result=row.chulzt;
            switch(row.chulzt)
            {
                case "1":
                    result="成功";
                    break;
                case "2":
                    result="失败";
                    break;
                case "0":
                    result="申领中";
                    break;
                case "3":
                    result="已撤销";
                    break;
            }
            return result;
        },
        getApplyInfoList() {
            let params = {
                likeSearch:this.likeSearchvalue,
                page: this.page,
                limit: this.pagenum,
                sort: "asc",
                order: "id",

            };
            this.$https.fetchPost('/inventory/getApplyInfoList', params).then(res => {
                console.log(res);
                this.tableData = res.data.data;
                this.total = res.data.count;
            })
        },submitForm(formName) {
            console.log(formName+"-->"+this.$refs[formName]);
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.addApplyInfo();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },addApplyInfo(){
            let params = {
                docApplyData:JSON.stringify(this.docApplyInfoForm)
            };
            console.log("params:"+JSON.stringify(params));
            this.$https.fetchPost('/inventory/addDocApply', params).then(res => {
                if (res.data.success) {
                    this.getApplyInfoList();
                    this.sldiag = false;
                }
            });
        },handleCheck(index,row,type){
            switch (type) {
                case "查看明细信息":
                    this.showDetail(row.id);
                    break;
                case "撤销申领":
                    this.backOutDocApply(row);
                    break;
            }
        },backOutDocApply(row)
        {
            if(row.chulzt==='3')
            {
                this.$message({
                    type: 'info',
                    message: this.$tolertJSON['018-3']
                });
                return;
            }
            let params = [];
            params.push(row.id);
            this.$https.fetchPost('/inventory/backOutDocApply', params).then(res => {
                if (res.data.success) {
                    this.getApplyInfoList();
                }
            });
        },batchBackOutDocApply()
        {
            let isBackOut=false;
            this.$confirm('此操作将批量撤销申领数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.selectIds.length<1) {
                    this.$message({
                        type: 'info',
                        message: this.$tolertJSON['007-2']
                    });
                }else {
                    let selectRows=this.selectRows;
                    console.log(selectRows);
                    selectRows.forEach(item=>{
                        if(item.chulzt==="3")
                        {
                            isBackOut=true;
                            throw new Error();
                        }
                    });
                    let params = this.selectIds;
                    this.$https.fetchPost('/inventory/backOutDocApply', params).then(res => {
                        if (res.data.success) {
                            this.getApplyInfoList();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    });
                }
            }).catch(() => {
                if(isBackOut)
                {
                    this.$message({
                        type: 'info',
                        message: this.$tolertJSON['018-3']
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '已取消撤销'
                    });
                }
            });
        },
        showDetail(id)
        {
            let params = {
                docApplyId:id
            };
            this.$https.fetchPost('/inventory/getDocApplyDetail', params).then(res => {
                console.log(JSON.parse(res.data.obj));
                this.detailTableData = JSON.parse(res.data.obj);
                this.showApplyDetailDialogVisible=true;
            });
        }/* 搜索 */
        ,changeserch(e) {
            this.likeSearchvalue = e;
            this.getApplyInfoList();
        },handleSelectionChange(e)
        {
            this.selectIds =[];
            this.selectRows=[];
            e.forEach((item, index) => {
                this.selectIds.push(item.id);
                this.selectRows.push(item);
            });
        },formaterFalxdm(row)
        {
            let result=row.faplxdm;
            switch(row.faplxdm)
            {
                case "026":
                    result="电子普票";
                    break;
                case "028":
                    result="电子专票";
                    break;
            }
            return result;
        },initSelectZhengjlx() {
            this.$https.fetchPost('config/getSelectByKey', "ID_TYPE").then(res => {
                this.selectZhengjlx = this.setSelectKey(JSON.parse(res.data.obj));
            });
        },
	}
};
</script>

<style scoped="scoped" lang="less">
	.diagtext{
		font-size: 14px;
		color: #333333;
		margin-bottom: 15px;
	}
// /deep/.el-dialog__body {
// 	padding: 0;
// }
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}


.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
thead .el-table-column--selection .cell {
    display: none!important;
}
</style>
